// Projects Block JavaScript
document.addEventListener('DOMContentLoaded', function() {
    const projectsBlocks = document.querySelectorAll('.projects-block');
    
    projectsBlocks.forEach(function(block) {
        const loadMoreButton = block.querySelector('.projects-block__more-button[data-action="load_more"]');
        
        if (!loadMoreButton) {
            return; // No load more button in this block
        }
        
        const moreOption = loadMoreButton.getAttribute('data-more-option');
        let currentlyDisplayed = parseInt(loadMoreButton.getAttribute('data-currently-displayed')) || 3;
        const totalProjects = parseInt(loadMoreButton.getAttribute('data-total')) || 0;
        const baseButtonText = loadMoreButton.getAttribute('data-base-text') || 'Atidaryti daugiau projektų';
        const buttonWrapper = loadMoreButton.closest('.projects-block__button-wrapper');
        
        // Function to get all currently hidden items (both big cards and grid items)
        function getHiddenItems() {
            const bigCards = block.querySelectorAll('.projects-block__item--hidden');
            const gridItems = block.querySelectorAll('.projects-block__grid-item--hidden');
            // Combine both NodeLists into a single array
            return Array.from(bigCards).concat(Array.from(gridItems));
        }
        
        // Function to update button text with remaining count
        function updateButtonText() {
            const remaining = totalProjects - currentlyDisplayed;
            if (remaining > 0) {
                loadMoreButton.textContent = baseButtonText + ' (' + remaining + ')';
                loadMoreButton.setAttribute('data-currently-displayed', currentlyDisplayed);
            } else {
                // All projects are shown, hide button
                if (buttonWrapper) {
                    buttonWrapper.style.display = 'none';
                }
            }
        }

        // Function to check and hide button if all projects are shown
        function checkAndHideButton() {
            const remainingHidden = getHiddenItems();
            if (remainingHidden.length === 0 || currentlyDisplayed >= totalProjects) {
                if (buttonWrapper) {
                    buttonWrapper.style.display = 'none';
                }
            } else {
                // Update button text with new count
                updateButtonText();
            }
        }
        
        // Function to show items with fade-in animation
        // Note: currentlyDisplayed should be updated BEFORE calling this function
        function showItemsWithAnimation(items, allAtOnce) {
            if (!items || items.length === 0) return;
            
            if (allAtOnce) {
                // Show all items at once with staggered fade-in
                items.forEach(function(item, index) {
                    // Remove hidden class first to make element visible (handle both big cards and grid items)
                    item.classList.remove('projects-block__item--hidden', 'projects-block__grid-item--hidden');
                    
                    // Force reflow to ensure the element is in the DOM
                    item.offsetHeight;
                    
                    // Add fade-in animation with slight delay for staggered effect
                    setTimeout(function() {
                        item.classList.add('projects-block__item--fade-in', 'projects-block__grid-item--fade-in');
                    }, index * 100); // 100ms delay between each item
                });
            } else {
                // Show items one by one with fade-in (for 3 more option)
                items.forEach(function(item, index) {
                    setTimeout(function() {
                        // Remove hidden class first (handle both big cards and grid items)
                        item.classList.remove('projects-block__item--hidden', 'projects-block__grid-item--hidden');
                        
                        // Force reflow
                        item.offsetHeight;
                        
                        // Add fade-in animation
                        item.classList.add('projects-block__item--fade-in', 'projects-block__grid-item--fade-in');
                    }, index * 150); // 150ms delay between each item for smooth sequence
                });
            }
        }

        loadMoreButton.addEventListener('click', function() {
            if (moreOption === 'all') {
                // Show all remaining projects with smooth fade-in
                const hiddenItems = getHiddenItems();
                const itemsCount = hiddenItems.length;
                showItemsWithAnimation(Array.from(hiddenItems), true);
                
                // Update count immediately (all will be shown)
                currentlyDisplayed += itemsCount;
                
                // Hide button after animation completes
                setTimeout(function() {
                    if (buttonWrapper) {
                        buttonWrapper.style.display = 'none';
                    }
                }, (itemsCount * 100) + 500); // Wait for animations to complete
                
            } else if (moreOption === '3_more') {
                // Show next 3 projects with smooth fade-in
                const hiddenItems = getHiddenItems();
                const itemsToShow = Math.min(3, hiddenItems.length);
                const itemsArray = Array.from(hiddenItems).slice(0, itemsToShow);
                
                // Update count before showing (for immediate button text update)
                currentlyDisplayed += itemsToShow;
                updateButtonText();
                
                showItemsWithAnimation(itemsArray, false);
                
                // Update displayed count attribute and button text after animation completes
                setTimeout(function() {
                    loadMoreButton.setAttribute('data-currently-displayed', currentlyDisplayed);
                    
                    // Check if button should be hidden after animations complete
                    setTimeout(function() {
                        checkAndHideButton();
                    }, 500);
                }, itemsToShow * 150);
            }
        });
    });
});
